import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiSettings, FiUsers } from "react-icons/fi";
import styles from "./Preset.module.scss";
import Axios from "../../../_services/caller.service";
import DefaultPresetConfig from "./defaultPresetConfig/DefaultPresetConfig";
import InjectPresets from "./injectPresets/InjectPresets";

const TABS = {
  CONFIG: "config",
  INJECT: "inject",
};

const Preset = () => {
  const { t } = useTranslation();
  const [allUser, setAllUser] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const [activeTab, setActiveTab] = useState(TABS.INJECT);

  useEffect(() => {
    Axios.get(`/getAllUserForSuperAdmin`)
      .then((response) => setAllUser(response.data.data))
      .catch(() => {});
  }, []);

  return (
    <div className={styles.container}>
      {overlay && <div className={styles.overlay}></div>}

      <div className={styles.header}>
        <h2>{t("preset.configuration_preset")}</h2>
      </div>

      <div className={styles.tabBar}>
        <button
          type="button"
          className={`${styles.tabBtn} ${
            activeTab === TABS.INJECT ? styles.tabActive : ""
          }`}
          onClick={() => setActiveTab(TABS.INJECT)}
        >
          <FiUsers /> {t("preset.tab_inject")}
        </button>
        <button
          type="button"
          className={`${styles.tabBtn} ${
            activeTab === TABS.CONFIG ? styles.tabActive : ""
          }`}
          onClick={() => setActiveTab(TABS.CONFIG)}
        >
          <FiSettings /> {t("preset.tab_config")}
        </button>
      </div>

      <div className={styles.content}>
        {activeTab === TABS.INJECT ? (
          <InjectPresets allUser={allUser} setOverlay={setOverlay} />
        ) : (
          <DefaultPresetConfig setOverlay={setOverlay} />
        )}
      </div>
    </div>
  );
};

export default Preset;
